// extracted by mini-css-extract-plugin
export var chevronIcon = "_bs-2";
export var teamName = "_bs-1";
export var teamSwitcherButton = "_bs-0";